import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlUtilsService } from '@utils/url-utils.service';
import { BaseService } from '@services/base-service.service';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { UtilitiesService } from '@services/utilities.service';
import { SwiperComponent } from 'swiper/angular';
import { BehaviorSubject, Subscription } from 'rxjs';
import { TableColumn } from '@shared/interface/table.interface';
import { IModalDetailWithImage, ModalConfig, ModalOption } from '@shared/components/modal/modal.interface';
import { BaseDatasource } from '@shared/base/base.datasource';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { API } from '@config/constants/api.constant';
import { SwallService } from '@services/swall.service';
import { ModalDetailWithImageComponent } from '@shared/components/modal/modal-detail-with-image/modal-detail-with-image.component';
import { IGenericIdName } from '@shared/interface/generic';
import { FilterService } from '@services/filter.service';
import { DistributorDetailService } from '../../../distributor-detail.service';
import { ICtaPrivilege, IDeleteProductExclusive, IKeyValue, IListDelete, IListProductExclusive } from '../../../interfaces/distributor.interface';
import { DistributorService } from '../../../distributor.service';
import { DistributorStatusEnum } from '@config/enum/distributor.enum';

@Component({
  selector: 'app-product-exclusive',
  templateUrl: './product-exclusive.component.html',
  styleUrls: ['./product-exclusive.component.scss'],
})
export class ProductExclusiveComponent implements OnInit, OnDestroy {
  @ViewChild('swiperVariant', { static: false }) swiperVariant: SwiperComponent;
  @Input() Data: BehaviorSubject<IListProductExclusive | undefined>;
  @Input() distributorInfo: any;
  tableColumns: TableColumn[];
  modalDetailConfig: ModalConfig;
  modalDetailOption: ModalOption;
  selectedList: string[] = [];
  displayedColumns: string[];
  isOther: boolean = false;
  string_filter: string = '';
  reason: string = '';
  submitted_at: string = '';

  listDeleteEnum: BehaviorSubject<IListDelete[]> = new BehaviorSubject<IListDelete[]>([]);
  productExclusiveList: IListProductExclusive[];
  baseDatasourceProductExclusive: BaseDatasource<IListProductExclusive>;
  detailProductExclusiveData: BehaviorSubject<IModalDetailWithImage> = new BehaviorSubject<IModalDetailWithImage>({} as IModalDetailWithImage);
  id: BehaviorSubject<string | null> = new BehaviorSubject<string | null>('');
  productId: BehaviorSubject<string | null> = new BehaviorSubject<string | null>('');
  urlPreview: BehaviorSubject<string | null> = new BehaviorSubject<string | null>('');
  imageList: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  parentMenu: string = 'DISTRIBUTOR';
  ctaPrivilege: BehaviorSubject<ICtaPrivilege> = new BehaviorSubject<ICtaPrivilege>({} as ICtaPrivilege);
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  ASSET_ICON = STRING_CONSTANTS.ICON;
  iconNone: string = STRING_CONSTANTS.ILLUSTRATIONS.IL_BOX_NONE;

  modalConfigDelete: ModalConfig = {
    modalTitle: 'DELETE PRODUCT EXCLUSIVE',
    closeButtonLabel: 'Cancel',
    dismissButtonLabel: 'Hapus',
    color: 'danger',
    disableDismissButton: () => this.modalDeleteButtonState(),
  };
  protected readonly BehaviorSubject = BehaviorSubject;
  @ViewChild('modalDelete') private modalDelete: ModalComponent;
  @ViewChild('modalDetail') private modalDetail: ModalDetailWithImageComponent;
  private unsubscribe: Subscription[] = [];

  get IsHaveProductExclusive() {
    return this.distributorInfo.tab === 'nonactive' && this.distributorService.DistributorDetailHeader.show_history_product_exclusive;
  }

  get ShowAddProductExclusive() {
    return this.distributorService.DistributorDetailHeader.status_enum === DistributorStatusEnum.ACTIVE;
  }

  constructor(
    private activeRoute: ActivatedRoute,
    private urlParamService: UrlUtilsService,
    private baseService: BaseService,
    private baseTableService: BaseTableService<any>,
    private activatedRoute: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private router: Router,
    public utilities: UtilitiesService,
    private swallService: SwallService,
    private filterService: FilterService,
    public distributorService: DistributorService,
    private detailDistributorService: DistributorDetailService
  ) {}

  ngOnInit(): void {
    this.getId();
    this.baseTableService.responseDatabase.subscribe((response) => (this.baseDatasourceProductExclusive = response));
    this.getListDelete();
    this.handlePrivilege();
    this.setTableData();
    this.queryHandler();
    this.initPageInfo();
  }

  getId() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id.next(params.get('id'));
    });

    this.modalDetailConfig = {
      showFooter: false,
      showHeader: false,
      onClose: () => {
        this.urlPreview.next(null);
        return true;
      },
    };

    this.modalDetailOption = {
      size: 'lg',
    };
  }

  handlePrivilege() {
    const _tabEnum = 'TAB_PRODUCT_EXCLUSIVE';
    const _privilege: ICtaPrivilege = {
      add: this.detailDistributorService.hasDetailPrivilege(_tabEnum, 'CTA_ADD_PRODUCT_EXCLUSIVE'),
      edit: this.detailDistributorService.hasDetailPrivilege(_tabEnum, 'CTA_EDIT_PRODUCT_EXCLUSIVE'),
      delete: this.detailDistributorService.hasDetailPrivilege(_tabEnum, 'CTA_DELETE_PRODUCT_EXCLUSIVE'),
      history: this.detailDistributorService.hasDetailPrivilege(_tabEnum, 'CTA_HISTORY_PRODUCT_EXCLUSIVE'),
    };

    this.ctaPrivilege.next(_privilege);
  }

  initPageInfo() {
    const dataSubs = this.baseDatasourceProductExclusive.tableSubject.subscribe((resp) => (this.productExclusiveList = resp));
    this.isLoading.next(false);
    this.unsubscribe.push(dataSubs);
  }

  setTableData() {
    this.tableColumns = [
      { title: 'PRODUK', key: 'product_name' },
      { title: 'VARIAN', key: 'list_variants' },
      { title: 'CAKUPAN AREA', key: 'area' },
      { title: 'CAKUPAN SUB AREA', key: 'list_sub_area' },
      { title: 'DIBUAT OLEH', key: 'submitted_by' },
      { title: 'TANGGAL DIBUAT', key: 'submitted_time' },
      { title: 'ACTION', key: 'actions' },
    ];

    this.displayedColumns = this.tableColumns.map((head) => head.key);

    if (this.productExclusiveList) {
      this.baseDatasourceProductExclusive.tableSubject.next(this.productExclusiveList);
    }
  }

  setDetailProduct(data: IListProductExclusive) {
    const title: string = 'DETAIL PRODUK EKSKLUSIF';
    const detail: IKeyValue[] = [
      { key: 'Produk', value: data.product_name },
      { key: 'Varian', value: this.mapVariantObject(data.list_variants) },
      { key: 'Cakupan Area', value: data.area },
      { key: 'Cakupan Sub Area', value: this.mapSubAreaObject(data.list_sub_area) },
      { key: 'Dibuat Oleh', value: data.submitted_by },
      {
        key: 'Tanggal Dibuat',
        value: data.submitted_time ? this.utilities.timeStampToDate(data.submitted_time, 'dd-MM-yyyy HH:mm:ss') : '-',
      },
      { key: 'Action', value: data.id },
    ];
    const images = data.product_document ? data.product_document : [];
    const privilege = { delete: this.ctaPrivilege.value.delete };
    this.submitted_at = data.submitted_time;
    this.detailProductExclusiveData.next({ title, detail, images, privilege });
  }

  queryHandler() {
    const paramSubs = this.activeRoute.queryParams.subscribe((data) => {
      this.string_filter = data.string_filter;
      const _queryParams = this.urlParamService.sliceQueryParams();
      this.loadDataTable(_queryParams ? _queryParams : '');
    });

    this.unsubscribe.push(paramSubs);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  loadDataTable(params: string) {
    return this.baseTableService.loadDataTable(API.GET_LIST_PRODUCT_EXCLUSIVE + this.id.value, params);
  }

  getListDelete = () => {
    this.baseService.getData<IListDelete[]>(API.LIST_PRODUCT_EXCLUSIVE_DELETE).subscribe((response) => {
      if (response) {
        this.listDeleteEnum.next(response.data);
      }
    });
  };

  toggleSelection(e: any) {
    this.isOther = this.utilities.otherToggleSelection(this.selectedList, e);
  }

  handleAction(data: IListProductExclusive) {
    const mainData = data;
    if (mainData) {
      this.modalDetail.setUrlPreview = mainData.product_document ? mainData.product_document[0] : '';
      this.modalDetail.setImageList = mainData.product_document ? mainData.product_document : [];
      this.setDetailProduct(mainData);
      this.ref.detectChanges();
      return this.modalDetail.openModal();
    }
  }

  changePageEvent($event: any) {
    this.filterService.changePageEvent($event, this.string_filter ?? '');
  }

  onSearch(event: string) {
    this.filterService.onSearch(event);
    this.string_filter = '';
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  handleDeleteProduct = (id: any) => {
    this.productId.next(id);
    this.modalDetail.closeModal().then();
    this.modalDelete.open().then();
    return;
  };

  handleGoTo(data: any = '', isEdit = false) {
    const { id_distributor, status, tab } = this.distributorInfo;
    return this.router.navigate(['/distributor/product-exclusive-settings/form'], {
      state: data,
      queryParams: {
        mode: isEdit ? 'edit' : 'add',
        id: id_distributor,
        status,
        tab,
      },
    });
  }

  handleHistory = () => this.router.navigate(['/distributor/product-exclusive/' + this.id.value]);

  submitForm = () => {
    const data = {
      distributor_id: this.id.value,
      brand_id: this.productId.value,
      reasons: this.selectedList,
      other_reason: this.reason,
      submitted_time: this.submitted_at,
    };

    this.baseService.deleteData<IDeleteProductExclusive>(API.DELETE_PRODUCT_EXCLUSIVE, data).subscribe((response) => {
      if (response) {
        if (response.success && response.message) {
          this.swallService
            .GetAlert({
              text: response.message,
            })
            .then(() => this.utilities.reloadPage());
          this.ref.detectChanges();
        }
      }
    });
  };

  modalDeleteButtonState() {
    let _isDisabled = true;
    if (this.selectedList.length > 0) {
      _isDisabled = this.isOther && !this.reason;
    }

    return _isDisabled;
  }

  setVariantItem(item: IGenericIdName[]) {
    if (item?.length) {
      const data = item[0].name;
      return {
        count: item.length - 1,
        name: data,
      };
    }
  }

  mapSubAreaObject(item: IGenericIdName[]) {
    const result = item?.length ? this.utilities.arrayStringJoin(item, 'name', ',', true) : 'SEMUA';
    return this.utilities.toCapitalize(result);
  }

  mapVariantObject(item: IGenericIdName[]) {
    const result = item?.length ? this.utilities.arrayStringJoin(item, 'name', ',', true) : '-';
    return this.utilities.toCapitalize(result);
  }

  protected readonly DistributorService = DistributorService;
}
